export const FORM_CONTROL_SX = {
  mt: 3,
  '& label.Mui-focused': { color: 'rgba(var(--textHigh))' },
  '& fieldset': { borderRadius: '12px', borderColor: 'rgba(var(--secondaryMidStroke))' },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': { borderColor: 'rgba(var(--secondaryMidStroke))' }
  }
} as const

export const MENU_PROPS = {
  PaperProps: {
    style: {
      maxHeight: 55 * 4.5 + 8,
      width: 250,
      backgroundColor: 'var(--color-surface-surfaceInverse)'
    }
  }
}

export const INIT_CENTER = { lat: 47.9221, lng: 106.9155 }

export const NETWORK_COVERAGE_TABS = [
  { id: 2, nameEN: 'Home Broadband', nameMN: 'Өрхийн интернэт' },
  { id: 1, nameEN: 'Network Coverage', nameMN: 'Сүлжээний хамрах хүрээ' },
  { id: 3, nameEN: 'Wi-Fi', nameMN: 'Wi-Fi' },
  { id: 4, nameEN: 'Travel Points', nameMN: 'Аяллын цэг' }
]

export const TAB_ID = {
  HBB: NETWORK_COVERAGE_TABS[0].id,
  NETWORK: NETWORK_COVERAGE_TABS[1].id,
  WIFI: NETWORK_COVERAGE_TABS[2].id,
  TRAVEL: NETWORK_COVERAGE_TABS[3].id
} as const

export const NETWORK_TYPES = [
  { id: 1, nameEN: '4G', nameMN: '4G' },
  { id: 2, nameEN: '5G', nameMN: '5G' }
]
